/**
 * IngredientsList custom element
 *
 * Desktop (≥ 750 px): hovering an ingredient item instantly shows the
 * corresponding image on the left (no CSS transition).
 * Mobile (< 750 px): no interaction — the image area is hidden via CSS.
 */
class IngredientsList extends HTMLElement {
  /** @type {MediaQueryList} */
  #mql = window.matchMedia('(min-width: 750px)');
  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    const items = /** @type {HTMLElement[]} */ ([
      ...this.querySelectorAll('.ingredients__item'),
    ]);
    if (!items.length) return;

    const slots = /** @type {HTMLElement[]} */ ([
      ...this.querySelectorAll('.ingredients__image-slot'),
    ]);
    this.#controller = new AbortController();

    this.addEventListener('mouseover', (e) => {
      if (!this.#mql.matches) return;
      const item = /** @type {Element} */ (e.target).closest('.ingredients__item');
      if (!item || item.classList.contains('is-active')) return;

      const { idx } = /** @type {HTMLElement} */ (item).dataset;
      items.forEach((el) => el.classList.toggle('is-active', el === item));
      slots.forEach((slot) => slot.classList.toggle('is-active', slot.dataset.idx === idx));
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }
}

if (!customElements.get('ingredients-list')) {
  customElements.define('ingredients-list', IngredientsList);
}